import React from 'react'


export const Plan = () => {
  return (
    <div className='plan' id='plans'>
      <h1>Choose Your Pricing Plan</h1>

      <div className='plandetails'>
        <div className='box1'>
          <div className="planbox1">
            <h1>Basic</h1>
            <h4>$ 49/ Mo</h4>
          </div>
          <div className='planbox2'>
            <ul>
              <ul>
                <li><ion-icon name="checkmark-sharp"></ion-icon>3 Trainings</li>
                <li><ion-icon name="checkmark-sharp"></ion-icon>Meal Plan</li>
                <li><span><ion-icon name="close-outline"></ion-icon></span>Doctor's Consultation</li>
                <li><span><ion-icon name="close-outline"></ion-icon></span>Cardio Workout</li>
                <li><span><ion-icon name="close-outline"></ion-icon></span>Training in Gym</li>
              </ul>
            </ul>
            <button className='price-btn'>Get Started</button>
          </div>
        </div>
        <div className='box2'>
          <div className="planbox1">
            <h1>Standard</h1>
            <h4>$ 69/ Mo</h4>
          </div>
          <div className='planbox2'>
            <ul c>
              <li><ion-icon name="checkmark-sharp"></ion-icon>3 Trainings</li>
              <li><ion-icon name="checkmark-sharp"></ion-icon>Meal Plan</li>
              <li><span><ion-icon name="close-outline"></ion-icon></span>Doctor's Consultation</li>
              <li><span><ion-icon name="close-outline"></ion-icon></span>Cardio Workout</li>
              <li><ion-icon name="checkmark-sharp"></ion-icon>Training in Gym</li>
            </ul>
            <button className='price-btn default'>Get Started</button>
          </div>
        </div>
        <div className='box3'>
          <div className="planbox1">
            <h1>Premium</h1>
            <h4>$ 99/ Mo</h4>
          </div>
          <div className='planbox2'>
            <ul>
              <li><ion-icon name="checkmark-sharp"></ion-icon>3 Trainings</li>
              <li><ion-icon name="checkmark-sharp"></ion-icon>Meal Plan</li>
              <li><span><ion-icon name="close-outline"></ion-icon></span>Doctor's Consultation</li>
              <li><ion-icon name="checkmark-sharp"></ion-icon>Cardio Workout</li>
              <li><ion-icon name="checkmark-sharp"></ion-icon>Training in Gym</li>
            </ul>
            <button className='price-btn'>Get Started</button>
          </div>
        </div>

      </div>
    </div>
  )
}
